import {EventPublisher} from 'app/demo/utils';

import {folders_list_fixture} from './folders';
import {lanes_list_fixture} from './lanes_list';
import {procedure_detail_fixture} from './procedure_detail';
import {procedure_version_detail_fixture} from './procedure_version_detail';
import {tags_list_fixture} from './tags_list';
import {teams_list_fixture} from './teams';
import {
  basic_account_owner_user_data_fixture,
  basic_user_data_fixture,
  user_data_fixture,
} from './user_data';
import {user_list_fixture} from './users';

import {
  AuthenticatedUserSerializedType,
  BasicUserSerializedType,
  LaneSerializedType,
  ListResponseType,
  ProcedureHashidSerializedType,
  ProcedureVersionSerializedType,
  RawFolderSerializedType,
  TagSerializedType,
  TeamSerializedType,
  UserSerializedType,
} from 'sweet-types';

const dataChangesPublisher = new EventPublisher();
let procedureDetailSource: ProcedureHashidSerializedType = {
  ...procedure_detail_fixture,
};
let procedureVersionSource: ProcedureVersionSerializedType = {
  ...procedure_version_detail_fixture,
};
let tagsListSource: ListResponseType<TagSerializedType> = {
  ...tags_list_fixture,
};
let lanesListSource: ListResponseType<LaneSerializedType> = {
  ...lanes_list_fixture,
};

let teamListSource: ListResponseType<TeamSerializedType> = {
  ...teams_list_fixture,
};

let folderListSource: ListResponseType<RawFolderSerializedType> = {
  ...folders_list_fixture,
};

let userListSource: ListResponseType<UserSerializedType> = {
  ...user_list_fixture,
};

let userDataSource: AuthenticatedUserSerializedType = {...user_data_fixture};
let basicUserDataSource: BasicUserSerializedType = {...basic_user_data_fixture};
let basicAccountOwnerUserDataSource: BasicUserSerializedType = {
  ...basic_account_owner_user_data_fixture,
};

export {
  dataChangesPublisher,
  procedureDetailSource,
  procedureVersionSource,
  tagsListSource,
  lanesListSource,
  userDataSource,
  basicUserDataSource,
  basicAccountOwnerUserDataSource,
  teamListSource,
  folderListSource,
  userListSource,
};
